<div class="form-page">
    <div class="logo-container-left">
        <img class="logo" src="assets/svg-icons/AP7_CX-BM-RGB.svg" alt="AP7_CX-BM-RGB Logo">
    </div>
    <div class="form-container-right">
        <main class="right-container-width">
            <h1>Danke für Ihre Registrierung! Wir freuen uns Sie auf Construct-X begrüßen zu dürfen.</h1>
            <p>Wir haben Ihnen eine E-Mail mit einem Bestätigungslink gesendet. Bitte überprüfen Sie Ihr Postfach – und
                schauen Sie zur Sicherheit auch im Spam-Ordner nach. Sobald Sie Ihre E-Mail bestätigt haben, können Sie
                loslegen.</p>
            <span>Kein Link erhalten? <a [routerLink]="['/resendMail']">Link erneut senden.</a></span>
        </main>
    </div>
</div>